"use client";
import { type ReactNode } from "react";
import "@/lib/storyblok";

export default function StoryblokProvider({
  children,
}: {
  children: ReactNode;
}) {
  return children;
}
